<div class="p-4 d-flex flex-column align-items-center">
  <div class="modal-header">
    <rs-web-icon
      [icon]="immomioIconName.Close"
      [style.cursor]="'pointer'"
      [size]="16"
      (click)="closeModal()"
    ></rs-web-icon>
  </div>

  <rs-web-image
    [defaultSrc]="'/web/images/png/address-change.png'"
    class="d-block mb-4"
  ></rs-web-image>
  <span class="title-xxl text-center">{{ title | translate }}</span>
  <div class="contract-info im:caption">
    <rs-web-icon [icon]="immomioIconName.House" [size]="12"></rs-web-icon>
    <span>
      {{ contract.address?.street }} {{ contract.address?.houseNumber }}
      @if (contract.externalId) {
        · {{ 'general.contract_number' | translate }} {{ contract.externalId }}
      }
    </span>
  </div>
  <p class="mb-4 text-center">{{ description | translate }}</p>
  <button im-button class="primary mb-4 w-100" (click)="goToTicketsCreation()">
    {{ goToTicketsText | translate }}
  </button>
  <button im-button class="inverted mb-4 w-100" (click)="setMovingAddressDone()">
    {{ alreadyDoneText | translate }}
  </button>
  <a im-button (click)="closeModal()">
    {{ linkText | translate }}
  </a>
</div>
